// document.addEventListener("DOMContentLoaded", function() {
//   const buyNowBtn = document.querySelector('.shopify-payment-button__button');
//   if (buyNowBtn) {
//     buyNowBtn.textContent = 'Buy Now';
//   }
// });
function updateBuyNowText() {
  const buttons = document.querySelectorAll('.shopify-payment-button__button');

  buttons.forEach(button => {
    button.innerHTML = 'Buy Now';
  });
}

document.addEventListener("DOMContentLoaded", updateBuyNowText);

// Re-run after Shopify updates
document.addEventListener("shopify:section:load", updateBuyNowText);

setInterval(updateBuyNowText, 1000);

// $(document).ready(function () {
//     $('.btn-cart').on('click', function () {
//       $('.cf-occ-btn').trigger('click');
//     });
//   });


